import PassengerTnesService from 'js/services/api/passenger/tnes.js'

import template from './new.pug'

const TNE_MEDIA_TYPE = '4'

export default Vue.extend({
  template: template(),
  data() {
    return {
      tne: {},
      errors: {},
      showAddedModal: false,
      showTneHelper: false
    }
  },
  computed: {
    hasTneMediaType() {
      if (!this.administrativeArea.media_types) { return true }

      return this.administrativeArea.media_types.findIndex(
        item => item.code === TNE_MEDIA_TYPE
      ) >= 0
    },

    accountId() {
      return this.$route.params.id
    },

    notErrors() {
      return _.isEmpty(this.errors)
    },

    defaultAlias() {
      return this.$t('balance.mediaTypes.4')
    }
  },
  watch: {
    administrativeArea: {
      handler() {
        if (!this.hasTneMediaType) { this.goToAccountBalance() }
      },
      immediate: true
    }
  },
  created() {
    this.setDefaultAlias()
  },
  methods: {
    setDefaultAlias() {
      this.tne.alias = this.tne.alias || this.defaultAlias
    },

    async createTne(params) {
      this.cleanErrors()
      params = {...params, account_id: this.accountId}
      try {
        const response = await PassengerTnesService.create(params)
        return {data: response, errors: {}}
      } catch (e) {
        if (e.data.errors) { return {errors: e.data.errors} }
        throw e
      }
    },

    async saveTne() {
      this.setDefaultAlias()
      const {data, errors} = await this.createTne(this.tne)
      this.setErrors(errors)
      if (data && this.notErrors) {
        this.toggleAddedModal()
      }
    },

    setErrors(errors) {
      this.errors = errors
    },

    cleanErrors() {
      this.setErrors({})
    },

    toggleAddedModal() {
      this.showAddedModal = !this.showAddedModal
    },

    goToAccountBalance() {
      this.$router.push({name: 'municipality-data-balance'})
    },

    toggleTneHelper() {
      this.showTneHelper = !this.showTneHelper
    }
  }
})
